import { Navbar } from "react-bootstrap";
import { useTenantContext } from "../../../context/Tenant/TenantContext";

const Brand = () => {
  const { config } = useTenantContext();

  return (
    <Navbar.Brand href="/">
      <img width="250px" src={config.mainLogo} alt="Logo" />
    </Navbar.Brand>
  );
};

export default Brand;
